import { isPlainObject } from 'lodash';

import type { AnyObj, Obj } from '../../typescript';

const stripEmpty = <T>(obj: AnyObj): Obj<T> => {
    if (!isPlainObject(obj)) {
        return obj;
    }
    const copy = { ...obj };
    for (const [k, v] of Object.entries(copy)) {
        if (v === undefined || (typeof v === 'string' && v.length === 0) || (Array.isArray(v) && v.length === 0)) {
            delete copy[k];
        }
    }
    return copy;
};

export { stripEmpty };
